export const candidatesStatus: {
  id: number;
  label: string;
  key: string;
  btnClass: string;
  class: string;
}[] = [
  {
    id: 0,
    label: 'Process initiated',
    key: 'STATUSES.CANDIDATES.PROCESS_INITIATED',
    btnClass: 'btn-pastel-gray',
    class: 'lnr lnr-hourglass'
  },
  {
    id: 1,
    label: 'Waitlisted',
    key: 'STATUSES.CANDIDATES.WAITLISTED',
    btnClass: 'btn-pastel-yellow',
    class: 'lnr lnr-hourglass'
  },
  {
    id: 2,
    label: 'Interview scheduled',
    key: 'STATUSES.CANDIDATES.INTERVIEW_SCHEDULED',
    btnClass: 'btn-pastel-yellow',
    class: 'lnr lnr-calendar-check'
  },
  {
    id: 3,
    label: 'Rejected',
    key: 'STATUSES.CANDIDATES.REJECTED',
    btnClass: 'btn-pastel-red',
    class: 'lnr lnr-cross'
  },
  {
    id: 4,
    label: 'Interviewed',
    key: 'STATUSES.CANDIDATES.INTERVIEWED',
    btnClass: 'btn-pastel-green',
    class: 'lnr lnr-check'
  },
  {
    id: 5,
    label: 'Completed',
    key: 'STATUSES.CANDIDATES.COMPLETED',
    btnClass: 'btn-pastel-green',
    class: 'lnr lnr-check'
  },
  {
    id: 6,
    label: 'Submitted',
    key: 'STATUSES.CANDIDATES.SUBMITTED',
    btnClass: 'btn-pastel-green',
    class: 'lnr lnr-check'
  },
  {
    id: 7,
    label: 'Accepted',
    key: 'STATUSES.CANDIDATES.ACCEPTED',
    btnClass: 'btn-pastel-green',
    class: 'lnr lnr-check'
  },
  {
    id: 8,
    label: 'Unresponsive',
    key: 'STATUSES.CANDIDATES.UNRESPONSIVE',
    btnClass: 'btn-pastel-red',
    class: 'lnr lnr-warning'
  }
];
